import alt from "../alt";
import indexBy from "lodash/keyBy";
import moment from "moment";

import BallotUtil from "../utils/BallotUtil";
import BallotActions from "../actions/BallotActions";
import PersonStore from "../stores/PersonStore";

import config from "../config";

class BallotStore {
  constructor() {
    this.bindActions(BallotActions);

    this.state = {
      votes: {},
      onlineBallotData: {}
    };

    this.exportPublicMethods({
      getDataForOnlineBallot: this.getDataForOnlineBallot.bind(this),
      getVotesForEvent: this.getVotesForEvent.bind(this)
    });
  }

  getDataForOnlineBallot(e) {
    return this.state.onlineBallotData[e];
  }

  getVotesForEvent(e) {
    return this.state.votes[e];
  }

  onFetchOnlineBallotData(params) {
    this.setState({ isWorking: true });

    BallotUtil.fetchOnlineBallotData(
      PersonStore.getState().token,
      params[0],
      params[1]
    )
      .then(data => {
        let onlineBallotData = Object.assign({}, this.state.onlineBallotData);
        onlineBallotData[params[0]] = data;
        this.setState({ onlineBallotData });
      })
      .catch(e =>
        window.alert(`Error fetching online ballot data: ${e.message}`)
      )
      .finally(() => {
        this.setState({ isWorking: false });
      });
  }

  onFetchVotes(eventId) {
    this.setState({ isWorking: true });

    BallotUtil.fetchVotes(PersonStore.getState().token, eventId)
      .then(data => {
        let votes = Object.assign({}, this.state.votes);
        votes[eventId] = data;
        this.setState({ votes });
      })
      .catch(e => window.alert(`Error fetching ballot votes: ${e.message}`))
      .finally(() => {
        this.setState({ isWorking: false });
      });
  }
}

export default alt.createStore(BallotStore, "BallotStore");



// WEBPACK FOOTER //
// ./src/app/stores/BallotStore.js